import { render } from "./ProfileControlButtons.vue?vue&type=template&id=361c483a&scoped=true&ts=true"
import script from "./ProfileControlButtons.vue?vue&type=script&lang=ts"
export * from "./ProfileControlButtons.vue?vue&type=script&lang=ts"

import "./ProfileControlButtons.vue?vue&type=style&index=0&id=361c483a&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361c483a"]])

export default __exports__